import * as React from 'react';
import { StyleSheet } from 'react-native';
import { useAuth } from '../auth/Auth';
import { Text } from 'react-native-elements';
import QRCode from 'qrcode.react'

import { View } from '../components/Themed';
import CalendarComponent from '../components/Calendar';

export default function CalendarScreen() {

  const {status, user} = useAuth()

  return (
    <View style={styles.container}>
        <CalendarComponent></CalendarComponent>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0fa8e4ff',
    alignItems: 'center',
    justifyContent: 'center',
    height: 400
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
});